import { getBare } from './httpRequest';

// eslint-disable-next-line import/prefer-default-export
export const fetchDietaryRequirements = async () => {
  const response = await getBare(`dietaryRequirements`);
  return response.data;
};
